var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showItemBundleItems
      ? _c(
          "div",
          { staticClass: "small font-weight-bold mb-3" },
          [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.$translate("Ceres::Template.itemBundleContent"))
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.bundleComponents, function (item) {
              return _c(
                "div",
                { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
                [
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(item.quantity) + " x"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "text-appearance",
                      attrs: { href: _vm._f("itemURL")(item.data) },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("itemName")(
                              _vm.getBundleInnerText(item.data)
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              )
            }),
          ],
          2
        )
      : _c("div", [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }